import { AddConferPage } from './pages/AddConferPage';
import { CompleteUserInformationPage } from './pages/CompleteUserInformationPage';
import { CurrrentPatientsPage } from './pages/CurrrentPatientsPage';
import { ListServiceConferPage } from './pages/ListServiceConferPage';
import { LoginPage } from './pages/LoginPage';
import { MainMenuPage } from './pages/MainMenuPage';
import { PatientListPage } from './pages/PatientListPage';
import { ServiceSummaryPage } from './pages/ServiceSummaryPage';
import { SignUpPage } from './pages/SignUpPage';
import { BankAccountListPage } from './pages/BankAccountListPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { ReferToPage } from './pages/ReferToPage';
import { NewReferralPage } from './pages/NewReferralPage';
import { GeneralSettingsDrawer } from './pages/GeneralSettingsDrawer';
import { DrawerLinksPage } from './pages/DrawerLinksPage';
import { UploadOnCallDocumentsPage } from './pages/UploadOnCallDocumentsPage';
import { PersonalizationDrawer } from './pages/PersonalizationDrawer';
import { GetNewTurn } from './pages/GetNewTurn';
import { TurnList } from './pages/TurnList';
import { LabTestResultPage } from './pages/LabTestResultPage';
import { FreezeContractsPage } from './pages/FreezeContractsPage';
import { GeneralPublicWords } from './pages/GeneralPublicWords';
import { ElectronicForms } from './pages/ElectronicForms';
import { InvoiceReceipt } from './pages/InvoiceReceipt';
import { QuarteringPage } from './pages/QuarteringPage';
import { Lab } from './pages/Lab';
import { Pato } from './pages/Pato';
import { TurnPrefrencesDrawer } from './pages/TurnPrefrencesDrawer';
import { webAppSettings } from './pages/webAppSettings';
import { SavePatientsForVisit } from './pages/SavePatientsForVisit';

const langauge = localStorage.getItem('UserLanguage');
const destinationLang = langauge
  ? langauge === 'en'
    ? 'en-US'
    : 'fa-IR'
  : 'fa-IR';
export const TranslationByPage = [
  // =========== general component =====s
  {
    FormKey: 'general-form-component-error-field',
    Key: 'فیلد',
    DistinitationLanguage: destinationLang,
  },

  {
    FormKey: 'general-form-component-error-fill-the',
    Key: 'را پر کنید',
    DistinitationLanguage: destinationLang,
  },

  //============ end ===================

  // ============ Login ===============
  ...LoginPage(destinationLang),
  // ============ end ===============

  // ============ Signup ===========
  ...SignUpPage(destinationLang),
  // ============ end ===============

  // ============ main menu =========
  ...MainMenuPage(destinationLang),
  // ============ end ===============

  // ============ current patients ==
  ...CurrrentPatientsPage(destinationLang),
  // ============ end ===============

  // ============ Add Confer ========
  ...AddConferPage(destinationLang),

  // ============ end ===============

  // ============ Patient list ======
  ...PatientListPage(destinationLang),
  // ============ end ===============

  // ============ Patient list ======

  ...ServiceSummaryPage(destinationLang),

  // ============ end ===============

  // ============ Add Medical Form ==
  {
    FormKey: 'add-medical-font-navbar-title',
    Key: 'ثبت پرونده',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'add-medical-font-alert-downloading',
    Key: 'درحال دانلود گزارش',
    DistinitationLanguage: destinationLang,
  },

  // ============ end ===============

  // ============ Edit Medical Form ==

  {
    FormKey: 'edit-medical-font-alert-save-sure',
    Key: 'آیا از ویرایش فرم اطمینان دارید',
    DistinitationLanguage: destinationLang,
  },

  // ============ end ===============

  // List service confer ============

  ...ListServiceConferPage(destinationLang),

  // ============ end ===============

  // List service confer ============

  ...NewReferralPage(destinationLang),

  // ============ end ===============

  // ============ Edit Confer service
  {
    FormKey: 'edit-confer-service-navbar-title',
    Key: 'ويرايش خدمت',
    DistinitationLanguage: destinationLang,
  },
  // ============ end ===============

  // ============ cancel redirect ===
  {
    FormKey:
      'current-patient-cancel-referal-confirmation-alert',
    Key: 'آيا از انصراف از ارجاع اطمينان داريد؟',
    DistinitationLanguage: destinationLang,
  },

  // ============ end ===============

  // ============ Messages Page =====
  {
    FormKey: 'messages-navbar-title',
    Key: 'پيام ها',
    DistinitationLanguage: destinationLang,
  },
  // ============ end ===============

  // ============ Complete User Info=

  ...CompleteUserInformationPage(destinationLang),

  // ============ end ===============

  // ============ About Us ==========
  {
    FormKey: 'general-public-about-us',
    Key: 'درباره ما',
    DistinitationLanguage: destinationLang,
  },

  // ============= end ==============

  // ============ Contact Us ==========

  // ============= end =================

  // ============ Bank Accounts list ===
  ...BankAccountListPage(destinationLang),
  // ============= end =================

  // ============ Bank Accounts list ===
  ...ChangePasswordPage(destinationLang),
  // ============= end =================

  // ============ Refer to =============
  ...ReferToPage(destinationLang),
  // ============= end =================

  // ============ settings drawer ====
  ...GeneralSettingsDrawer(destinationLang),
  // ============= end =================

  // ============ Lab test results ====
  ...LabTestResultPage(destinationLang),
  // ============= end =================

  // ============ Add Edit common ====
  {
    FormKey: 'confer-add-edit-common-label-patient-payable',
    Key: 'سهم بیمار',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey:
      'confer-add-edit-common-label-insurance-payable',
    Key: 'سهم بیمه',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'confer-add-edit-common-label-total-price',
    Key: 'مبلغ کل',
    DistinitationLanguage: destinationLang,
  },
  // ============= end ================

  // ============= Get New Turn =======

  ...GetNewTurn(destinationLang),

  // ============= end ================

  // ============ drawer links =========
  ...DrawerLinksPage(destinationLang),

  // ============ General Public =======

  // ============ Personalization Drawer =========
  ...PersonalizationDrawer(destinationLang),

  // ============ General Public =======

  // ============ drawer links =========
  ...UploadOnCallDocumentsPage(destinationLang),
  // ============ turn list ============
  ...TurnList(destinationLang),
  // ============ Freeze Contract ============
  ...FreezeContractsPage(destinationLang),
  // ============ General Public =======
  ...GeneralPublicWords(destinationLang),
  // ============ Electronic Forms =======
  ...ElectronicForms(destinationLang),
  // ============ Invoice Receipts ============
  ...InvoiceReceipt(destinationLang),
  // ============ Quartering ==================
  ...QuarteringPage(destinationLang),
  // ============ Lab ==================

  ...Lab(destinationLang),
  //============== Token ===============

  //============== Pato  ===============

  ...Pato(destinationLang),
  //=================================

  //============== Turn Prefrence drawer
  ...TurnPrefrencesDrawer(destinationLang),
  //====================================

  //============== Web App settings
  ...webAppSettings(destinationLang),

  //=============== Save Patients For visit page

  ...SavePatientsForVisit(destinationLang),

  //============================================

  {
    FormKey: 'token-expire-alert-expired',
    Key: 'توکن منقضی شده است',
    DistinitationLanguage: destinationLang,
  },
  //============== end ==============

  // ============= settings ========
  {
    FormKey: 'general-public-setting-language',
    Key: 'زبان',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-setting-color',
    Key: 'رنگ بندی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-alert-doing-request',
    Key: 'درحال انجام...',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-contact-us',
    Key: 'تماس با ما',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-alert-downloading',
    Key: 'درحال دریافت...',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-btn-download',
    Key: 'دریافت',
    DistinitationLanguage: destinationLang,
  },
  // {
  //   FormKey: "general-public-title-name-motamed",
  //   Key: "پژوهشکده معتمد جهاد دانشگاهی",
  //   DistinitationLanguage: destinationLang,
  // },
  {
    FormKey: 'general-public-label-add',
    Key: 'افزودن',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-label-title',
    Key: 'تیتر',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-edit-medical-form',
    Key: 'ویرایش فرم',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-wep-app-settings',
    Key: 'وب اپلیکیشن',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-customization-settings',
    Key: 'زبان و شخصی سازی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-wep-app-video-call-title',
    Key: 'مکالمه تصویری',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-all',
    Key: 'همه',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-show-by',
    Key: 'نمایش',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-btn-label-download-file',
    Key: 'دریافت فایل',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-btn-label-download-picture',
    Key: 'دریافت تصویر',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-btn-label-open-file',
    Key: 'مشاهده فایل',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-route-title-survey',
    Key: 'نظرسنجی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-price-item',
    Key: 'مبلغ',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-wallet-balance',
    Key: 'موجودی به ریال',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-tooman',
    Key: 'تومان',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-pay-wallet',
    Key: 'پرداخت',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-no-access-label',
    Key: 'دسترسی برای شما تعریف نشده است',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-show-editor',
    Key: 'نمایشگر تصویر',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-verify-transaction',
    Key: 'درحال تایید تراکنش',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey:
      'genral-public-transaction-receipt-receive-error',
    Key: 'خطا در دریافت رسید تراکنش',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-personal',
    Key: 'ارسال شده توسط خودتان',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-send-from-center',
    Key: 'ارسال شده از مرکز',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-select-file-type',
    Key: 'انتخاب نوع فایل',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-send-file-prompt',
    Key: 'آیا از ارسال فایل اطمینان دارید؟',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'genral-public-label-sent-items',
    Key: 'ارسال شده ها',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'user-pishnahad-route-title',
    Key: 'پیشنهادات و انتقادات',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'user-survey-route-title',
    Key: 'نظر سنجی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-btn-name-fill-form',
    Key: 'پر کردن فرم',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'survey-navbar-title-survey-form',
    Key: 'فرم نظر سنجی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'patient-survey-list-filter-name-survey-type',
    Key: 'نمایش فرم های نظر سنجی بر اساس',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey:
      'patient-survey-list-filter-list-filled-form-selection',
    Key: 'ثبت شده',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey:
      'patient-survey-list-filter-list-not-filled-form-selection',
    Key: 'ثبت نشده',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'patient-cartable-navbar-title',
    Key: 'کارتابل بیمار',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'patients-for-visit-navbar-title',
    Key: 'بیماران پزشک',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'patients-for-visit-hospital-unit-name',
    Key: 'واحد',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'patients-for-visit-summary-input-label',
    Key: 'انواع خلاصه پرونده',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-word-gender',
    Key: 'جنسیت',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-uploader-label-upload-file',
    Key: 'بارگذاری فایل',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-label-national-code',
    Key: 'کدملی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-label-reset-items',
    Key: 'بازنشانی',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-label-patient-role',
    Key: 'درمانخواه',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-label-doctor-role',
    Key: 'درمانگر',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-copyright-notice',
    Key: 'کلیه حقوق این سامانه متعلق به شرکت مهندسی راشن سیستم آریا می باشد',
    DistinitationLanguage: destinationLang,
  },
  {
    FormKey: 'general-public-cant-login-system',
    Key: 'امکان ورود به سامانه وجود ندارد',
    DistinitationLanguage: destinationLang,
  },

  // ============== end ==============

  // ============ end ===============
];
